import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import { LockKeyhole, ShieldCheck } from "lucide-react";

type Mode = "register" | "login";

export default function Acesso() {
  const navigate = useNavigate();
  const [mode, setMode] = useState<Mode>("register");
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [user, setUser] = useState<{ name: string; email: string } | null>(null);
  const [paid, setPaid] = useState(false);
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);

  const refresh = () => fetch("api/auth/me", { credentials: "include" }).then(async r => {
    if (!r.ok) return;
    const data = await r.json();
    setUser(data.user);
    setPaid(Boolean(data.paid));
    if (data.paid) navigate("/teste", { replace: true });
  }).catch(() => {});

  useEffect(() => { refresh(); }, []);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setBusy(true); setMessage("");
    const endpoint = mode === "register" ? "register" : "login";
    const response = await fetch(`api/auth/${endpoint}`, {
      method: "POST", credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form),
    });
    const data = await response.json();
    setBusy(false);
    if (!response.ok) return setMessage(data.error || "Não foi possível continuar.");
    setUser(data.user); setPaid(Boolean(data.paid));
    if (data.paid) navigate("/teste");
  }

  async function buy() {
    setBusy(true); setMessage("");
    const response = await fetch("api/access/checkout", { credentials: "include" });
    const data = await response.json();
    setBusy(false);
    if (!response.ok) return setMessage(data.error || "Checkout indisponível.");
    window.location.href = data.url;
  }

  return <div className="clinic-site"><Header/><main className="checkout-page">
    <section className="checkout-card">
      <ShieldCheck className="checkout-symbol" size={38}/>
      <p className="eyebrow">ACESSO PROTEGIDO</p>
      <h1>{user ? `Olá, ${user.name}.` : mode === "register" ? "Crie sua conta" : "Entre na sua conta"}</h1>
      {!user ? <>
        <p className="checkout-description">Sua conta guarda o pagamento, o progresso do questionário e os conteúdos liberados.</p>
        <form onSubmit={submit} className="access-form">
          {mode === "register" && <input required placeholder="Nome completo" value={form.name} onChange={e=>setForm({...form,name:e.target.value})}/>}
          <input required type="email" placeholder="E-mail" value={form.email} onChange={e=>setForm({...form,email:e.target.value})}/>
          <input required minLength={8} type="password" placeholder="Senha (mínimo de 8 caracteres)" value={form.password} onChange={e=>setForm({...form,password:e.target.value})}/>
          {message && <p className="checkout-notice">{message}</p>}
          <button className="clinic-button" disabled={busy}>{busy ? "Aguarde…" : mode === "register" ? "Criar conta e continuar" : "Entrar"}</button>
        </form>
        <button className="text-link" onClick={()=>{setMode(mode==="register"?"login":"register");setMessage("");}}>
          {mode === "register" ? "Já tenho conta" : "Quero criar minha conta"}
        </button>
      </> : <>
        <p className="checkout-description">Pagamento único para liberar o questionário completo e os vídeos do seu resultado.</p>
        <div className="checkout-total"><span>Questionário de Análise dos Doshas</span><strong>R$ 9,90</strong></div>
        {message && <p className="checkout-notice">{message}</p>}
        <button className="clinic-button" onClick={paid ? ()=>navigate("/teste") : buy} disabled={busy}>
          {paid ? "Continuar para o questionário" : busy ? "Abrindo checkout…" : "Comprar e liberar meu acesso"}
        </button>
        <p className="legal-note"><LockKeyhole size={14}/> O questionário só é liberado após a confirmação do pagamento.</p>
      </>}
    </section>
  </main><Footer/></div>;
}
